<template lang="pug">
.page-container
  .header
    .header-card(:style="store.levelInfo && store.levelInfo.cardStyle")
      .header-card-left(@click="()=>handleClickHead(0)")
        .member-title(v-if="store.user")
          img.member-portrait(:src="store.user.headPortrait")
          span.member-nickname {{ store.user.nickName }}
        .member-level-name(
          v-if="store.levelInfo && store.levelInfo.currentLevel"
        ) {{ store.levelInfo.currentLevel.levelName }}
        .member-level-desc(
          v-if="store.levelInfo && store.levelInfo.currentLevel"
        ) {{ store.levelInfo.currentLevel.levelDesc }}
        .member-level-expire(v-if="store.levelInfo") ({{ store.levelInfo.endDateStr }} 到期)
      .header-card-right(v-if="store.levelInfo" @click="()=>handleClickHead(1)")
        .member-upgrade-title 成长值
        .member-upgrade-count {{ store.levelInfo.currentPoint }}
        .member-detail-btn 查看明细
    .header-rights
      .rights-item(
        v-for="item in store.propertyList"
        :key="item.propGuid"
        @click="() => handleClickRight(item)"
      )
        .top-mark(:class="{'app-only': item.topMarkAppOnly}")
          img.top-mark-bg(
            v-if="item.topMark"
            :src="item.topMark"
          )
          .top-mark-text(v-if="item.topMarkText") {{ item.topMarkText }}
        img.rights-item-img(v-if="item.propStatus===1" :src="item.propActiveIcon")
        img.rights-item-img(v-if="item.propStatus===0" src="@/assets/member/icon_suo@2x.png")
        span.rights-item-text {{ item.propName }}

  .task
    h3.task-title
     | 每日任务
     i.task-help(@click="handleGoHelp")

    .task-list
      .task-item(
        v-for="item in store.taskList"
        :key="item.taskGuid"
        :class="{'is-download-app': item.isDownloadApp}"
      )
        img.task-item-icon(:src="item.taskIcon")
        .task-item-body
          .body-left
            .task-item-name {{ item.taskName }}
            .task-item-desc {{ item.awardDesc }}
          .body-right
            .task-item-btn(
              :class="{disabled: item.completeStatus !== 0}"
              @click="()=>handleDoTask(item)"
            ) {{ getTaskBtnName(item)  }}

  level-up-modal(ref="levelUpModal")
</template>
<script>
import { Native } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import levelUpModal from './components/levelUpModal';
import {
  store,
  loadUserInfo,
  loadSwitchStatus,
  initUserBaseInfo,
  loadUserLevelInfo,
  loadUserTasks,
  initBaseProperty,
  updateUserProperty,
} from './store';
import prerender from './prerender';
import { isPreRender } from '../../utils';

export default {
  components: {
    levelUpModal,
  },
  data() {
    return {
      taskGuid: '',
      store: store.state,
    };
  },
  created() {
    prerender();
  },
  async mounted() {
    UBT.moduleExpose({
      pageId: 'APP_我的_会员中心首页新',
      categoryId: 'platform',
      moduleId: 'platform_rights',
      contentId: 'platform_rights',
      exposureTimes: 1,
      businessInfo: {},
    });
    UBT.moduleExpose({
      pageId: 'platform_LV_VIP',
      categoryId: 'platform',
      moduleId: 'platform_lv_card',
      contentId: 'platform_lv_card',
      exposureTimes: 1,
      businessInfo: {},
    });
    UBT.pageView({
      pageId: 'platform_LV_VIP',
      categoryId: 'platform',
      businessInfo: {},
    });
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }

    Native.callNative({
      method: 'setNavigationBar',
      params: {
        title: '会员中心',
        backgroundColor: '#2d3139',
      },
    });

    await initUserBaseInfo();
    loadSwitchStatus();
    loadUserInfo();
    loadUserLevelInfo(true).then((info) => {
      if (info.upgradeNoticeFlag) {
        this.$refs.levelUpModal.open(info.currentLevel);
      }
    });
    initBaseProperty()
      .then(updateUserProperty);
    loadUserTasks();
  },
  destroyed() {
    UBT.pageViewOut({
      pageId: 'platform_LV_VIP',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  methods: {
    getTaskBtnName(item) {
      if (item.completeStatus === 1) {
        return '已完成';
      }
      if (item.completeStatus === 2) {
        return '今日已完成';
      }
      return item.actionName;
    },
    handleDoTask(item) {
      this.taskGuid = item.taskGuid;
      UBT.clickButton({
        pageId: 'APP_我的_会员中心首页新',
        buttonName: 'platform_daily_task',
        categoryId: 'platform',
        businessInfo: {
          taskid: this.taskGuid,
        },
      });
      if (item.completeStatus !== 0 || !item.xcxActionUrl) {
        return;
      }
      Native.callNative({
        method: 'goOperationUrl',
        params: item.xcxActionUrl,
      });
    },
    handleClickHead(type) {
      UBT.clickButton({
        pageId: 'platform_LV_VIP',
        buttonName: 'platform_lv_card',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$router.push({
        name: 'memberDetail',
        query: {
          type,
        },
      });
    },
    handleClickRight(item) {
      UBT.clickButton({
        pageId: 'APP_我的_会员中心首页新',
        buttonName: 'platform_rights',
        categoryId: 'platform',
        businessInfo: {
          business: '所属业务线',
        },
      });
      this.$router.push({
        name: 'memberRights',
        query: {
          guid: item.propGuid,
        },
      });
    },
    handleGoHelp() {
      window.location.href = 'https://m.hellobike.com/ebike-h5/latest/index.html#/activity/common?guid=fbf5d67b427643b9bc03d9a44835b5eb';
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  height: 100%;
  background-color: #f5f5f5;

  .header {
    background-image: url('~@/assets/member/BG_1@2x.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 100%;
    padding-top: 0.1rem;
    background-color: #fff;
    margin-bottom: 0.1rem;

    .header-card {
      margin: auto;
      width: 3.51rem;
      min-height: 1.6rem;
      font-size: 12px;
      padding: 0.16rem 0.2rem 0.11rem 0.2rem;
      background: #fff;
      // background-image: url('~@/assets/member/BG_baiyin@2x.png');
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 6px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
      margin-bottom: 0.26rem;
      display: flex;

      .header-card-left {
        flex: 1;
      }

      .header-card-right {
        width: 80px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .member-title {
        display: flex;
        align-items: center;
        margin-bottom: 0.2rem;

        .member-portrait {
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 0.2rem;
          margin-right: 0.06rem;
        }

        .member-nickname {
          display: inline-block;
          color: #fff;
          font-size: 12px;
        }
      }

      .member-level-name {
        font-size: 0.24rem;
        color: #fff;
        font-weight: 400;
        line-height: 0.33rem;
        margin-bottom: 0.06rem;
      }

      .member-level-desc {
        max-width: 1.53rem;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        margin-bottom: 0.06rem;
      }

      .member-level-expire {
        font-size: 10px;
        color: rgba(0, 0, 0, 0.5);
        line-height: 14px;
      }

      .member-upgrade-title {
        font-size: 12px;
        color: #fff;
        line-height: 17px;
        margin-bottom: 0.04rem;
      }

      .member-upgrade-count {
        font-size: 0.32rem;
        line-height: 0.37rem;
        color: #fff;
        font-weight: 400;
        margin-bottom: 0.04rem;
      }

      .member-detail-btn {
        background-color: #121c40;
        border-radius: 0.1rem;
        opacity: 0.2;
        font-size: 12px;
        line-height: 12px;
        color: #fff;
        padding: 0.04rem 0.08rem;
      }
    }

    .header-rights {
      padding: 0 0.12rem;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      padding-bottom: 0.05rem;

      .rights-item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 25%;
        margin-bottom: 0.15rem;

        .rights-item-img {
          width: 0.46rem;
          height: 0.46rem;
          margin-bottom: 0.06rem;
        }

        .rights-item-text {
          display: block;
          color: #666;
          font-size: 12px;
          line-height: 17px;
        }

        .top-mark {
          position: absolute;
          z-index: 1;
          top: -0.05rem;
          left: 55%;
          width: 30px;
          height: 14px;
          text-align: center;

          &.app-only {
            width: 48px;
            height: 18px;
            top: -0.08rem;
          }

          .top-mark-bg {
            position: absolute;
            z-index: 1;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }

          .top-mark-text {
            position: relative;
            z-index: 2;
            font-size: 10px;
            color: #fff;
            line-height: 14px;
          }
        }
      }
    }
  }

  .task {
    background: #fff;

    .task-title {
      padding: 0.16rem 0.15rem;
      font-size: 18px;
      font-weight: 400;
      color: #333;

      .task-help {
        width: 0.16rem;
        height: 0.16rem;
        display: inline-block;
        background-image: url('~@/assets/member/wenhao@2x.png');
        background-size: cover;
        vertical-align: middle;
        margin-bottom: 2px;
        margin-left: 5px;
      }
    }

    .task-list {
      padding-bottom: 12px;

      .task-item {
        display: flex;
        padding: 0.2rem 0.15rem 0;

        .task-item-icon {
          width: 0.42rem;
          height: 0.42rem;
          margin-right: 0.1rem;
        }

        .task-item-body {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 0.2rem;

          .task-item-name {
            font-size: 16px;
            line-height: 18px;
            font-weight: 400;
            color: #333;
            margin-bottom: 0.1rem;
          }

          .task-item-desc {
            color: #d8903c;
            font-size: 12px;
            line-height: 12px;
          }

          .task-item-btn {
            border-radius: 19px;
            text-align: center;
            font-size: 13px;
            line-height: 26px;
            padding: 0 0.13rem;
            color: #fff;
            background:
              linear-gradient(
                131deg,
                rgba(236, 190, 119, 1) 0%,
                rgba(224, 166, 74, 1) 100%
              );

            &.disabled {
              background: #f5f5f5;
              color: #bbb;
            }
          }
        }

        &:not(:last-child) {
          .task-item-body {
            border-bottom: solid 1px rgba(238, 238, 238, 0.5);
          }
        }

        &.is-download-app {
          background: #f5f8f9;

          .task-item-desc {
            color: #0b82f1;
          }

          .task-item-btn {
            background:
              linear-gradient(
                90deg,
                rgba(11, 170, 241, 1) 0%,
                rgba(11, 130, 241, 1) 100%
              );
          }
        }
      }
    }
  }
}
</style>
